import { classNames } from "@/utility/jsx";
import { type FocusEvent, type KeyboardEvent, useRef } from "react";
import "./style.scss";

interface EditableTextboxProps {
  className?: string;
  value?: string | null;
  placeholder?: string;
  onSave?: (text: string) => void;
  blurOnEnterKey?: boolean;
  noLineBreak?: boolean;
}

export const EditableTextbox = ({
  className,
  value,
  placeholder,
  onSave,
  blurOnEnterKey,
  noLineBreak,
}: EditableTextboxProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleOnKeyDown = (event: KeyboardEvent) => {
    if (blurOnEnterKey === false) {
      return;
    }
    if (event.key === "Enter") {
      if (ref.current) {
        ref.current.blur();
      }
    }
    return;
  };

  const handleOnBlur = (e: FocusEvent) => {
    const newText = e.target.textContent || "";
    onSave?.(newText.trim());

    if (ref.current && noLineBreak) {
      // Scroll div to start, so text-overflow: ellipsis displays correctly
      ref.current.scrollLeft = 0;
    }
  };

  return (
    <div
      ref={ref}
      data-testid="editable-input"
      data-placeholder={placeholder}
      className={classNames(
        onSave ? "editable-textbox text-cursor" : "editable-textbox",
        className,
        noLineBreak ? "no-line-break" : undefined,
      )}
      onKeyDown={handleOnKeyDown}
      onBlur={handleOnBlur}
      suppressContentEditableWarning
      contentEditable={!!onSave}
    >
      {value}
    </div>
  );
};
